import { render, staticRenderFns } from "./SubCardColumna.vue?vue&type=template&id=ab0cee5c&"
import script from "./SubCardColumna.vue?vue&type=script&lang=js&"
export * from "./SubCardColumna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports